/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import PasswordChecklist from 'react-password-checklist';
import {
  PLACEHOLDER_NEW_PASSWORD,
  PLACEHOLDER_CONFIRM_PASSWORD,
  RESET_PASSWORD_PASSWORD_MESSAGE,
  RESET_PASSWORD_CONFIRM_PASSWORD_MESSAGE,
  // RESET_PASSWORD_VERIFY_TOKEN,
  LABEL_RETURN_LOGIN,
  CREATE_PASSWORD_TITLE,
  CREATE_PASSWORD_MESSAGE,
  CREATE_PASSWORD_BTN,
  NEW_USER_PASSWORD_SUCCESS_MESSAGE,
  RESET_PASSWORD_VERIFY_TOKEN
} from '../../constants/constant';
import { InputAdornment, TextField } from '@mui/material';
import AuthLayout from '../Layouts/Authlayout';
import type { ResetPasswordInputFields,CreatePasswordProps, ResetPasswordResponse } from '../types/types';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import '../Styles/reset-password.css';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { createUserPassword } from 'src/services/userService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { resetverifyToken } from 'src/services/forgotPasswordService';
import Loader from '../Loader';
// import Loader from '../Loader';

interface ApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
  }
export default function CreatePassword(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('q');
  const [loading, setLoading] = useState<boolean>(false);
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true);
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(true);
  const [invalidToken, setInvalidToken] = useState<boolean>(false);
  const [verifyToken, setVerifyToken] = useState<boolean>(false);
  // const [invalidToken, setInvalidToken] = useState<boolean>(false);
  // const [loader, setLoader] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  // console.log(loader);
   console.log(error);


  const validationSchema = Yup.object().shape({
    newPassword: Yup.string().required(RESET_PASSWORD_PASSWORD_MESSAGE),
    confirmPassword: Yup.string()
      .required(RESET_PASSWORD_CONFIRM_PASSWORD_MESSAGE)
      .oneOf([Yup.ref('newPassword')], 'Confirm password should match new password'),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    clearErrors
  } = useForm<ResetPasswordInputFields>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  function handleSetPassword(e: React.ChangeEvent<HTMLInputElement>): void {
    const value = e.target.value;
    setNewPassword(value);
    if (value === confirmPassword) {
      clearErrors('confirmPassword');
    } else {
      void trigger('confirmPassword');
    }
  }

  function handleSetMatchPassword(e: React.ChangeEvent<HTMLInputElement>): void {
    const value = e.target.value;
    setConfirmPassword(value);
    if (value === newPassword) {
      clearErrors('confirmPassword');
    } else {
      void trigger('confirmPassword');
    }
  }


  useEffect(() => {

    if (token != null && token !== '') {
    //   console.log(token);
    //   console.log(decodeURIComponent(token));

      resetverifyToken(decodeURIComponent(token)) 
        .then((res: ResetPasswordResponse) => {
        
          if (res.status === 200 && res.data.result === 1) {
            setVerifyToken(true);
            setLoading(true)
          } else {
            setInvalidToken(true);
            setLoading(false);
            setError("Invalid or expired token.");
          }
        })
        .catch((error) => {
            setInvalidToken(true);
          console.error('Error:', error);
          setError("Something went wrong. Please try again.");
        })
        .finally(() => setLoading(false)); // Stop loader
    } else {
      setInvalidToken(true);
      setLoading(false);
    }
  }, [token]);
  useEffect(() => {
    if (newPassword === confirmPassword) {
      clearErrors('confirmPassword');
    }
  }, [newPassword, confirmPassword, clearErrors]);
  const onSubmit = async (data: ResetPasswordInputFields): Promise<void> => {

    setLoading(true);
    setMessage("");
    const newToken = token != null ? decodeURIComponent(token) : '';
    const params : CreatePasswordProps =
    {
      password: data.newPassword,
      confirmPassword: data.confirmPassword,
      token: newToken
    }
    
    setMessage("");
    setLoading(true);

    createUserPassword(params  ).then(
      (res: ApiResponse) => {
        if (res.status === 200 && res.data.result === 1) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
          NotificationManager.success(NEW_USER_PASSWORD_SUCCESS_MESSAGE);
          setLoading(false);
          setTimeout(() => {
            navigate('/');
          }, 500); 
        } else {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
          NotificationManager.error(res.data.messages);
          setLoading(false);
        }

      }). catch((error: any) => {
        console.error("Error updating role:", error);
        setLoading(false)
    }) .finally(() => setLoading(false));;
  };



  const handleBackLogin = (): void => {
    navigate('/')
  }
  return (
    <AuthLayout>
      {(invalidToken || verifyToken ) ? "" : <div className="text-center"><Loader/></div>}
      {verifyToken ? (
      <div>
        <h1 className="text-center text-[18px] font-bold text-muted mb-[15px]">{CREATE_PASSWORD_TITLE}</h1>
        <p className="text-subtitle text-center text-[14px] mb-[35px]">{CREATE_PASSWORD_MESSAGE}</p>

      </div>
       ) : ""}
      <div className="login-content w-full">
        {invalidToken  ? (
          <div>
            <p className="text-subtitle text-center text-[14px] mb-[35px]">{RESET_PASSWORD_VERIFY_TOKEN}</p>
            <button onClick={() => handleBackLogin()} className="btn btn-block bg-gradient-to-b border-0 from-red to-primary h-[45px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white">{"Return to login"}</button>
          </div>
        ) : ""}
        {message !== "" && (
          <div className="w-full mb-[15px] border border-primary bg-inputerror rounded-lg text-center pt-[10px] pb-[13px] text-14 font-semibold text-primary">
            <span>{message}</span>
          </div>
        )}
        {verifyToken ?  
        
        <div>
          <form onSubmit={(e) => {
            e.preventDefault();
            void handleSubmit(onSubmit)(e);
          }} className={`${(!isValid && (newPassword !== "" || confirmPassword !== "")) ? 'form-error' : ''}`}>
            <div className="mb-8 w-full relative">
              <Controller
                name="newPassword"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    id="newPassword"
                    name="newPassword"
                    autoComplete="off"
                    label="New Password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder={PLACEHOLDER_NEW_PASSWORD}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src="/assets/images/input-password.svg" alt="email" width={22} height={22} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={showPassword ? '/assets/images/show-password.svg' : '/assets/images/close-password.svg'}
                            onClick={() => setShowPassword(!showPassword)}
                            alt="email"
                            width={22}
                            height={20}
                            className="cursor-pointer"
                          />
                        </InputAdornment>
                      ),
                    }}

                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      handleSetPassword(e);
                      field.onChange(e);
                    }}
                    error={Boolean(errors.newPassword)}
                    helperText={
                      errors.newPassword ? (
                        <span className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1d3jg1r pl-3" style={{ display: 'flex', alignItems: 'center' }}>
                          <ReportProblemOutlinedIcon style={{ color: '#ed4b52', fontSize: '12px', marginRight: '4px' }} />
                          {errors.newPassword.message}
                        </span>
                      ) : null
                    }
                  />
                )}
              />
            </div>

            <div className="mb-7 w-full relative">
              <Controller
                name="confirmPassword"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    id="confirmPassword"
                    name="confirmPassword"
                    autoComplete="off"
                    label="Confirm Password"
                    type={confirmShowPassword ? 'text' : 'password'}
                    placeholder={PLACEHOLDER_CONFIRM_PASSWORD}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src="/assets/images/input-password.svg" alt="password-icon" width={22} height={22} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <img
                            src={confirmShowPassword ? '/assets/images/show-password.svg' : '/assets/images/close-password.svg'}
                            onClick={() => setConfirmShowPassword(!confirmShowPassword)}
                            alt="toggle-visibility"
                            width={22}
                            height={20}
                            className="cursor-pointer"
                          />
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      handleSetMatchPassword(e);
                      field.onChange(e);
                    }}
                    error={Boolean(errors.confirmPassword)}
                    helperText={
                      errors.confirmPassword ? (
                        <span className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1d3jg1r pl-3" style={{ display: 'flex', alignItems: 'center' }}>
                          <ReportProblemOutlinedIcon style={{ color: '#ed4b52', fontSize: '12px', marginRight: '4px' }} />
                          {errors.confirmPassword.message}
                        </span>
                      ) : null
                    }
                  />
                )}
              />
            </div>
<div>
            <PasswordChecklist
              rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
              minLength={8}
              value={newPassword}
              valueAgain={confirmPassword}
              iconSize={10}
              className={"password-checklist"}
              iconComponents={{ ValidIcon: <img src="/assets/images/checklist-complete.svg" width={15} height={15} />, InvalidIcon: <img src="/assets/images/checklist.svg" width={10} height={10} /> }}
              messages={{
                minLength: "At least 8 characters long",
                specialChar: "One special character",
                number: "One number",
                capital: "One capital letter",
                match: "Confirm password should match new password",
              }}
              onChange={(isValid: boolean) => {
                setIsValid(isValid);
                isValid ? setBtnDisabled(false) : setBtnDisabled(true)
              }}
            />
</div>
            <button type="submit" disabled={loading || btnDisabled} className={btnDisabled ? "btn btn-block bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[45px] text-14 capitalize hover:from-[#D6242C] hover:to-[#ED4B52] focus-visible:outline-none rounded-50 font-semibold disabled:bg-primary cursor-not-allowed disabled:opacity-100 disabled:text-white" : "btn btn-block bg-gradient-to-b border-0 from-red to-primary h-[45px] hover:from-[#D6242C] hover:to-[#ED4B52] text-14 capitalize focus-visible:outline-none rounded-50 font-semibold text-white"}>{!loading ? `${CREATE_PASSWORD_BTN}` : <span className="loading loading-spinner loading-xs text-white"></span>}</button>

          </form>
          <div className="text-center  mt-[15px]">
            <a href="/" className="text-center text-muted underline hover:text-primary text-14 inline-block">{LABEL_RETURN_LOGIN}</a>
          </div>
        </div>
         :''
      } 

      </div>
    </AuthLayout>
  );
}
